<div class="p-grid" *ngIf="processo !== undefined" xmlns="http://www.w3.org/1999/html">
  <div class="p-col-3">
    <div class="overflow-time-line">
      <div class="card">
        <div *ngFor="let linha of listaLinhaTempos">
          <div class="p-field p-text-center p-col-12 date-timeline">
            <p-badge value="{{(linha[0].getData() | date: 'dd/MM/yyyy') }}"></p-badge>
          </div>
          <p-timeline [value]="linha">
            <ng-template  pTemplate="content" let-linhaDoTempo>
              <div class="p-fluid conteudo-person m-b-10">
                <div class="p-field p-grid" style="display: contents; cursor: pointer" (click)="abrirDetalhes(linhaDoTempo)">
                  <div class="p-col-12 p-m-sm-12">
                    <i [ngClass]='linhaDoTempo.getIcone()' class="icone-time-line cl-blue"></i>
                      <label class="tipo-time-line p-text-bold cl-blue"> {{linhaDoTempo.getTipo()}}</label><br>
                  </div>
                  <div class="p-col-12 p-m-sm-12">
                    <div class="m-t-5 p-text-break">{{linhaDoTempo.getDescricao()}}</div>
                  </div>
                  <div class="p-col-12 p-m-sm-12 p-text-right">
                    <i class="pi pi-clock pi-clock-time-line"> </i><span class="m-l-2">{{linhaDoTempo.getData() | date: 'HH:mm'}}</span>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-timeline>
        </div>
        <div class="p-grid p-box-time-line">
          <div class="p-col p-text-center">
            <button pButton pRipple type="button" label="Ver mais" class="p-button-primary p-button-text"  *ngIf="fimPaginacaoDocumentos || fimPaginacaoMovimentos" (click)="carregarMais()"></button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="p-col-9">
    <div *ngIf="apresentarClasse">
      <p-card>
        <ng-template pTemplate="header">
          <div class="title-visualizacao"><span class="cl-blue">Classe: </span>
            <span>{{ processoClasseSelecionada.classe.descricao }}</span>
          </div>
        </ng-template>
        <div class="p-fluid">
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id:</label>
            <div class="p-col-12 p-md-10">{{processoClasseSelecionada.id}}</div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Origem Id:</label>
            <div class="p-col-12 p-md-10">{{processoClasseSelecionada.origemId}}</div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Data início:</label>
            <div class="p-col-12 p-md-10">{{processoClasseSelecionada.dataInicio | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Data fim:</label>
            <div class="p-col-12 p-md-10">{{processoClasseSelecionada.dataFim | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Classe:</label>
            <div class="p-col-12 p-md-10">
              <a [routerLink]="['/classe/visualizar',processoClasseSelecionada.classe.id]"> {{ processoClasseSelecionada.classe.descricao}} </a>
              <br />
              <div *ngIf="processoClasseSelecionada.classe.id === -1 && processoClasseSelecionada.classeRecebidaId !== null">Id recebido:
                {{ processoClasseSelecionada.classeRecebidaId}}
              </div>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <div *ngIf="apresentarDistribuicao">
      <p-card>
        <ng-template pTemplate="header">
          <div class="title-visualizacao"><span class="cl-blue">Distribuição: </span>
            <span *ngIf="isSegundoGrau()"> {{processoDistribuicaoSelecionada?.orgaoJulgadorColegiadoLocal?.nome}} </span>
            <span *ngIf="processoDistribuicaoSelecionada.orgaoJulgador.id === -1"> {{processo.distribuicaoAtual.orgaoJulgadorLocal.nome}} </span>
            <span *ngIf="processoDistribuicaoSelecionada.orgaoJulgador.id !== -1"> {{processoDistribuicaoSelecionada.orgaoJulgador.nome}} </span>
          </div>
        </ng-template>
        <div class="p-fluid">
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id:</label>
            <div class="p-col-12 p-md-10">{{processoDistribuicaoSelecionada.id}}</div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Origem Id:</label>
            <div class="p-col-12 p-md-10">{{processoDistribuicaoSelecionada.origemId}}</div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Data início:</label>
            <div class="p-col-12 p-md-10">{{processoDistribuicaoSelecionada.dataInicio | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Data fim:</label>
            <div class="p-col-12 p-md-10">{{processoDistribuicaoSelecionada.dataFim | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Órgão Julgador:</label>
            <div class="p-col-12 p-md-10">
              <div *ngIf="isSegundoGrau()">
                <a [routerLink]="['/orgaoJulgadorColegiadoLocal/visualizar/', processoDistribuicaoSelecionada.orgaoJulgadorColegiadoLocal.id]">
                  {{processoDistribuicaoSelecionada?.orgaoJulgadorColegiadoLocal?.nome}}
                </a>
              </div>
              <div>
                <span *ngIf="processoDistribuicaoSelecionada.orgaoJulgador.id === -1">
                  <a [routerLink]="['/orgaoJulgadorLocal/visualizar/', processoDistribuicaoSelecionada.orgaoJulgadorLocal.id]">
                    {{processo.distribuicaoAtual.orgaoJulgadorLocal.nome}}
                  </a>
                </span>
                <span *ngIf="processoDistribuicaoSelecionada.orgaoJulgador.id !== -1">
                  <a [routerLink]="['/orgaoJulgador/visualizar/', processoDistribuicaoSelecionada.orgaoJulgador.id]">
                    {{processoDistribuicaoSelecionada.orgaoJulgador.nome}}
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <div *ngIf="apresentarDocumento">
      <p-card>
        <ng-template pTemplate="header">
          <div class="title-visualizacao"><span class="cl-blue">Documentos: </span>
            <span> {{processoDocumentoSelecionada.nome}} </span>
          </div>
        </ng-template>
        <div class="p-fluid">
          <div *ngIf="processoDocumentoSelecionada !== undefined">
            <app-processo-documento-comparacao-texto-original #dlgProcessoDocumentoComparacao [processoDocumento]="processoDocumento">
            </app-processo-documento-comparacao-texto-original>
            <p-tabView [(activeIndex)]="tabViewDocumentosIndex" (onChange)="onChangeTabViewDocumentos()">
              <p-tabPanel header="Dados">
                <div class="p-grid">
                  <div class="p-col-4 p-text-bold">Id:</div>
                  <div class="p-col-8">{{processoDocumentoSelecionada.id}}</div>
                </div>
                <div class="p-grid">
                  <div class="p-col-4 p-text-bold">Nome:</div>
                  <div class="p-col-8">{{processoDocumentoSelecionada.nome}}</div>
                </div>
                <div class="p-grid">
                  <div class="p-col-4 p-text-bold">Origem Id:</div>
                  <div class="p-col-8">{{processoDocumentoSelecionada.origemId}}</div>
                </div>
                <div class="p-grid">
                  <div class="p-col-4 p-text-bold">Data de juntada:</div>
                  <div class="p-col-8">{{processoDocumentoSelecionada.dataJuntada | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
                </div>
                <div class="p-grid" *ngIf="processoDocumentoSelecionada.excluido">
                  <div class="p-col-4">Data da exclusão: </div>
                  <div class="p-col-8">{{processoDocumentoSelecionada.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
                </div>
                <div class="p-grid">
                  <div class="p-col-4 p-text-bold">Tipo:</div>
                  <div class="p-col-8">
                    <a href="tipoProcessoDocumento/visualizar/{{processoDocumentoSelecionada.tipo.id}}">
                      {{processoDocumentoSelecionada.tipo.id}} - {{processoDocumentoSelecionada.tipo.nome}}
                    </a>
                  </div>
                </div>
                <div class="p-grid">
                  <div class="p-col-4 p-text-bold">Tipo de arquivo: </div>
                  <div class="p-col-8">{{processoDocumentoSelecionada.categoriaArquivo}} - {{processoDocumentoSelecionada.tipoArquivo}}
                  </div>
                </div>
                <div class="p-grid" *ngIf="processoDocumentoSelecionada?.signatarios?.length > 0">
                  <div class="p-col-4 p-text-bold">Signatários: </div>
                  <div class="p-col-8">
                    <li *ngFor="let signatario of processoDocumentoSelecionada.signatarios">
                      <a href="/pessoa/visualizar/{{signatario.signatario.id}}">{{signatario.signatario.nome}}</a>
                    </li>
                  </div>
                </div>
              </p-tabPanel>
              <p-tabPanel header="Arquivo" [disabled]="!processoDocumentoSelecionada.processado">
                <div *ngIf="processoDocumentoSelecionada.processado">
                  <div class="p-grid">
                    <div class="p-col-4 p-text-bold">Id: </div>
                    <div class="p-col-8">{{processoDocumentoSelecionada.arquivo.id}}</div>
                  </div>
                  <div class="p-grid">
                    <div class="p-col-4 p-text-bold">Tipo: </div>
                    <div class="p-col-8">{{processoDocumentoSelecionada.arquivo.categoriaArquivo}} - {{processoDocumentoSelecionada.arquivo.tipo}}
                    </div>
                  </div>
                  <div class="p-grid">
                    <div class="p-col-4 p-text-bold">Hash: </div>
                    <div class="p-col-8">{{processoDocumentoSelecionada.arquivo.hash}}</div>
                  </div>
                  <div class="p-grid">
                    <div class="p-col-4 p-text-bold">Tamanho do arquivo original: </div>
                    <div class="p-col-8">{{processoDocumentoSelecionada.arquivo.tamanho / 1024}}kb</div>
                  </div>
                  <div class="p-grid">
                    <div class="p-col-4 p-text-bold">Tamanho do arquivo texto: </div>
                    <div class="p-col-8">{{processoDocumentoSelecionada.arquivo.tamanhoTexto}}bytes</div>
                  </div>
                  <div class="p-grid">
                    <div class="p-col-4">Transformações: </div>
                    <div class="p-col-8">{{processoDocumentoSelecionada.arquivo.transformacoes}}</div>
                  </div>
                  <div class="p-grid">
                    <div class="p-col-4 p-text-bold">Data do processamento: </div>
                    <div class="p-col-8">{{processoDocumentoSelecionada.arquivo.dataProcessamento | date: 'dd/MM/yyyy HH:mm:ss'}}
                    </div>
                  </div>
                  <div class="p-grid">
                    <div class="p-col-4 p-text-bold">Tempo do processamento: </div>
                    <div class="p-col-8">{{processoDocumentoSelecionada.arquivo.tempoProcessamento}}ms</div>
                  </div>
                  <div class="p-grid">
                    <div class="p-col-4 p-text-bold">Tempo de conversão: </div>
                    <div class="p-col-8">{{processoDocumentoSelecionada.arquivo.tempoConversao}}ms</div>
                  </div>
                  <div class="p-grid">
                    <div class="p-col-4 p-text-bold">Versão do prisma: </div>
                    <div class="p-col-8">{{processoDocumentoSelecionada.arquivo.versaoPrisma}}</div>
                  </div>
                  <div class="p-grid">
                    <div class="p-col-4 p-text-bold">Quantidade de páginas: </div>
                    <div class="p-col-8">{{processoDocumentoSelecionada.arquivo.quantidadePaginas}}</div>
                  </div>
                  <div class="p-grid">
                    <div class="p-col-4 p-text-bold">Quantidade de imagens: </div>
                    <div class="p-col-8">{{processoDocumentoSelecionada.arquivo.quantidadeImagens}}</div>
                  </div>
                </div>
              </p-tabPanel>
              <p-tabPanel header="Texto" [disabled]="!processoDocumentoSelecionada.processado">
                <div class="processo-documento-texto">
                  <div [innerText]="processoDocumentoTexto" *ngIf="processoDocumentoSelecionada.processado"></div>
                  <div *ngIf="!processoDocumentoSelecionada.processado">
                    <span class="fa pi-exclamation-triangle pendente"></span> O texto do documento ainda não foi
                    extraído.
                  </div>
                </div>
              </p-tabPanel>
              <p-tabPanel header="Original">
                <app-arquivo-visualizador [arquivo]="processoDocumentoArquivo"></app-arquivo-visualizador>
              </p-tabPanel>
            </p-tabView>
          </div>
        </div>
      </p-card>
    </div>
    <div *ngIf="apresentarMovimento">
      <p-card>
        <ng-template pTemplate="header">
          <div class="title-visualizacao"><span class="cl-blue">Movimento: </span>
            <span> {{processoMovimentoSelecionada.descricao}} </span>
          </div>
        </ng-template>
        <div class="p-fluid">
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id:</label>
            <div class="p-col-12 p-md-10">{{processoMovimentoSelecionada.id}}</div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Origem Id: </label>
            <div class="p-col-12 p-md-10">{{processoMovimentoSelecionada.origemId}}</div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Data: </label>
            <div class="p-col-12 p-md-10">
              <span>{{processoMovimentoSelecionada.data | date: 'dd/MM/yyyy HH:mm:ss'}}</span><br />
              <span *ngIf="processoMovimentoSelecionada.dataExclusao" class="exclusao">Excluído em:
                {{processoMovimentoSelecionada.dataExclusao | date:'dd/MM/yyyy HH:mm:ss'}}
            </span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Tipo: </label>
            <div class="p-col-12 p-md-10">
              <strong>
                <a [routerLink]="['/tipoMovimento/visualizar', processoMovimentoSelecionada.tipo.id]">
                  {{processoMovimentoSelecionada.tipo.id}}  - {{processoMovimentoSelecionada.tipo.nome}}
                </a>
              </strong>
              <br>
              <div *ngIf="processoMovimentoSelecionada.tipo.id === -1 && tipoMovimentoRecebidoId !== null">
                Id recebido: {{processoMovimentoSelecionada.tipoMovimentoRecebidoId}}
              </div>
              {{processoMovimentoSelecionada.descricao}}
            </div>
          </div>
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Documento: </label>
            <div class="p-col-12 p-md-10">
              <span *ngIf="processoMovimentoSelecionada?.documento; else noDocumento">
                <a class="button-acao cursor-pointer" (click)="dlgVlzDadosMovimento.visualizarDadosDocumentos(processoMovimentoSelecionada.documento, processo)">
                  {{processoMovimentoSelecionada.documento.nome}}
                </a>
              </span>
              <ng-template #noDocumento><span class="text-danger">Não existe documento para ser visualizado.</span></ng-template>
            </div>
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Classe:</label>
          <div class="p-col-12 p-md-10">
              <span *ngIf="processoMovimentoSelecionada?.classe; else noClasseTemplate">
                <a [routerLink]="['/classe/visualizar', processoMovimentoSelecionada.classe.id]" class="cursor-pointer">
                  {{ processoMovimentoSelecionada.classe.id }}
                </a>
                <br />
                <div *ngIf="processoMovimentoSelecionada.classe.id === -1 && processoMovimentoSelecionada.classe.classeRecebidaId !== null">
                  Id recebido: {{ processoMovimentoSelecionada.classe.classeRecebidaId }}
                </div>
              </span>
            <ng-template #noClasseTemplate><span class="text-danger">Não existe classe para este movimento.</span></ng-template>
          </div>
        </div>
        <div *ngIf="processoMovimentoSelecionada.distribuicao === null">
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Distribuição:</label>
            <div class="p-col-12 p-md-10"><span class="text-danger">Não existe distribuição este o movimento.</span></div>
          </div>
        </div>
        <div *ngIf="processoMovimentoSelecionada.distribuicao">
          <div class="p-fluid">
            <div class="p-field p-grid">
              <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Distribuição:</label>
              <div class="p-col-12 p-md-10">
                <span *ngIf="processoMovimentoSelecionada.distribuicao.orgaoJulgador.id === -1">
                  <a [routerLink]="['/orgaoJulgadorLocal/visualizar/', processoMovimentoSelecionada.distribuicao.orgaoJulgadorLocal.id]">
                    {{processoMovimentoSelecionada.distribuicao.orgaoJulgadorLocal.nome}}
                  </a>
                </span>
                <span *ngIf="processoMovimentoSelecionada.distribuicao.orgaoJulgador.id !== -1">
                  <a [routerLink]="['/orgaoJulgador/visualizar/', processoMovimentoSelecionada.distribuicao.orgaoJulgador.id]">
                    {{processoMovimentoSelecionada.distribuicao.orgaoJulgador.nome}}
                  </a>
                </span>
              </div>
            </div>
          </div>
          <br>
          <div  *ngIf="processoMovimentoSelecionada?.complementos && processoMovimentoSelecionada?.complementos.length > 0 ">
            <div class="time-line-complementos">
              <span class="timeline-subtitulo-dados">Complementos </span>
            </div>
            <br>
            <table  class="table-person">
              <tr *ngIf="!processoMovimentoSelecionada.complementos || processoMovimentoSelecionada.complementos.length === 0">
                <td colspan="7">
                  <span>Não existe <strong>complementos</strong> para o movimento {{processoMovimentoSelecionada.id}}</span>
                </td>
              </tr>
              <tr *ngIf="processoMovimentoSelecionada?.complementos && processoMovimentoSelecionada?.complementos.length > 0 ">
                <td colspan="7" >
                  <table class="table-person">
                    <tr>
                      <th rowspan="2" class="p-text-center" style="width: 155px;">
                        <app-rotulo></app-rotulo>
                      </th>
                      <th colspan="3"  class="p-text-center">Tipo</th>
                      <th rowspan="2" class="p-text-center">Tabelado</th>
                      <th rowspan="2" class="p-text-center">Valor</th>
                    </tr>
                    <tr><th>Categoria</th><th>Descrição</th><th>Observação</th></tr>
                    <tr *ngFor="let complemento of processoMovimentoSelecionada.complementos">
                      <td class="p-text-center">
                          <span *ngIf="!processoMovimentoSelecionada.dataExclusao">
                            <app-id
                              [id]="complemento.id"
                              [origemId]="complemento.origemId">
                            </app-id>
                          </span>
                        <span *ngIf="processoMovimentoSelecionada.dataExclusao">
                            <i class="pi pi-exclamation-circle person-exclamation" pTooltip="Excluído em: {{processoMovimentoSelecionada.dataExclusao | date:'dd/MM/yyyy HH:mm:ss'}}"></i>
                            &nbsp;
                             <span class="p-text-taxado">
                              <app-id
                                [id]="complemento.id"
                                [origemId]="complemento.origemId">
                              </app-id>
                            </span>
                          </span>
                      </td>
                      <td>
                        <span *ngIf="processoMovimentoSelecionada.complementos">
                          {{complemento.tipo.categoria}}
                        </span>
                      </td>
                      <td>
                        <a [routerLink]="['/tipoComplemento/visualizar/', complemento?.tipo?.id]">{{complemento.tipo.descricao}}</a>
                      </td>
                      <td><span>{{complemento.tipo.observacao}}</span></td>
                      <td>{{complemento?.tabelado?.descricao}}</td>
                      <td>{{complemento.valor}}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </p-card>
    </div>
  </div>
</div>
